import script from "./product-process-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./product-process-tab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__